__turbopack_context__.v({
  "footerColumn": "NewDefaultFooter-module-scss-module__fSE7Va__footerColumn",
  "footerRow": "NewDefaultFooter-module-scss-module__fSE7Va__footerRow",
  "footerSection": "NewDefaultFooter-module-scss-module__fSE7Va__footerSection",
});
